var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "maren-sol" },
      [
        _c("el-container", { staticClass: "d-flex-column" }, [
          _c("h1", [
            _vm._v("Maren "),
            _c("span", { staticClass: "d-block" }, [_vm._v("Solutions")])
          ]),
          _c("p", { staticStyle: { "font-size": "18px" } }, [
            _vm._v("We are committed to building Relationships"),
            _c("span", { staticClass: "d-block" })
          ])
        ])
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "maren-comm" },
      [
        _c(
          "el-container",
          { staticClass: "d-flex-column" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 10 } }, [
                  _c("img", {
                    staticClass: "img-responsive",
                    attrs: {
                      src: require("../../../public/img/home/communicate.svg"),
                      alt: "Communicate"
                    }
                  })
                ]),
                _c("el-col", { attrs: { span: 14 } }, [
                  _c("h2", [
                    _vm._v("Communicate "),
                    _c("span", { staticClass: "d-block" }, [
                      _vm._v("Collaborate and")
                    ]),
                    _vm._v(" Growth")
                  ]),
                  _c("p", [
                    _vm._v(
                      "With worldly wise of experience in designing, and delivering complex software application, \n            we believe our team a blend of on-shore and off-shore talent creating tailored software products. we ensure that the final solution is eminent and well documented "
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "maren-vision" },
      [
        _c("el-container", { staticClass: "d-flex-column" }, [
          _c("ul", { staticClass: "vision-list" }, [
            _c("li", [
              _c("h2", [
                _vm._v("Vision of "),
                _c("span", { staticClass: "d-block" }, [
                  _vm._v("Maren Solutions")
                ])
              ]),
              _c("h5", [_vm._v("We are committed to building relationships.")])
            ]),
            _c("li", [
              _c("img", {
                attrs: {
                  src: require("../../../public/img/home/diamond.svg"),
                  alt: "Diamond"
                }
              }),
              _c("h4", [_vm._v("Value & Importance")]),
              _c("p", [
                _vm._v("Maren solutions values the "),
                _c("span", { staticClass: "d-block" }, [
                  _vm._v("importance of open")
                ]),
                _vm._v(" communication")
              ])
            ]),
            _c("li", [
              _c("img", {
                attrs: {
                  src: require("../../../public/img/home/promises.svg"),
                  alt: "Promises"
                }
              }),
              _c("h4", [_vm._v("Promises")]),
              _c("p", [
                _vm._v("We adhere to our promises and "),
                _c("span", { staticClass: "d-block" }, [
                  _vm._v("meet the deadlines")
                ])
              ])
            ]),
            _c("li", [
              _c("img", {
                attrs: {
                  src: require("../../../public/img/home/output.svg"),
                  alt: "Promises"
                }
              }),
              _c("h4", [_vm._v("Best Output")]),
              _c("p", [
                _vm._v("We provide Collaborate "),
                _c("span", { staticClass: "d-block" }, [
                  _vm._v("training for the best output")
                ])
              ])
            ]),
            _c("li", [
              _c("img", {
                attrs: {
                  src: require("../../../public/img/home/relationship.svg"),
                  alt: "Diamond"
                }
              }),
              _c("h4", [_vm._v("Relationship")]),
              _c("p", [
                _vm._v(
                  "With decades of domain knowledge, our subject matter experts provide insightful information to enhance our customer relationship"
                )
              ])
            ]),
            _c("li", [
              _c("img", {
                attrs: {
                  src: require("../../../public/img/home/support.svg"),
                  alt: "Promises"
                }
              }),
              _c("h4", [_vm._v("Implementation and support")]),
              _c("p", [
                _vm._v(
                  "For additional long-term security, we offer support contracts that includes software maintainance and enhancements"
                )
              ])
            ])
          ])
        ]),
        _c("img", {
          staticClass: "objects",
          attrs: {
            src: require("../../../public/img/home/objects.svg"),
            alt: "Object"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/Home.vue?vue&type=template&id=f40bc054&
// module id = 550
// module chunks = 0